import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-ie-no-support',
  templateUrl: './ie-no-support.component.html',
  styleUrls: ['./ie-no-support.component.scss'],
})
export class IeNoSupportComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<IeNoSupportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {}

  onNoClick(): void {
    this.dialogRef.close();
  }
  openSupport(){
    window.open('https://lionshelp.zendesk.com/hc/en-us');
  }
}
